<div [innerHTML]="content"></div>
